import Vue from 'vue';
import store from '@/store';
import $ from 'jquery'

import AddProductModal from './AddProductModal.vue';

export default function(){
    let element = $(`<div id="gnzs-1c-amo__add-product-modal-container"></div>`)
    $('body').append(element)

    new Vue({
        store,
        render: h => h(AddProductModal)
    }).$mount('#gnzs-1c-amo__add-product-modal-container');
}